import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import styles from './ParticipatingOrgSearchList.module.scss';
import loadingIcon from '../../../assets/images/np_loading.png';
import crossIcon from '../../../assets/images/x-circle.svg';
import _ from 'lodash';
import { sortOrganisationsByCategory } from '../../../utils/SortHelper';
import NominateOrganisation from '../nominateOrganisation/NominateOrganisation';
import ReactModal from 'react-modal';
import ParticipatingOrgSearchItem from '../participatingOrgSearchItem/participatingOrgSearchItem';
import Modal from 'react-modal';
import Button from '../button/Button';
import TextInput from '../textInput/TextInput';
import { nominateOrganisation } from '../../../redux/actions';

ReactModal.setAppElement('#root');

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
  },
};

const ParticipatingOrgSearchList = props => {
  const dispatch = useDispatch();
  const participatingOrganisationsData = useSelector(state => state.participatingOrganisations);
  const { searchingOrganisations, organisationNames, categories } = participatingOrganisationsData;

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchByName, setSearchByName] = useState('');
  const [isFilterModalOpen, setFilterModalOpen] = useState(false);
  const [isStateInfoModalOpen, setStateInfoModalOpen] = useState(false);
  const [isOptionsOpen, setOpenOtions] = useState(false);
  const [openIndex, setOpenIndex] = useState([]);
  const [nominatedOrganisations, setNominatedOrganisations] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const participatingOrganisationsByCategory =
    organisationNames && sortOrganisationsByCategory([...organisationNames]);

  const filteredCategories = participatingOrganisationsByCategory
    .filter(org => {
      if (!selectedCategories || !selectedCategories.length) {
        return true;
      } else {
        return !!selectedCategories.find(sc => sc.value === org.sector);
      }
    })
    .filter(org => {
      if (!searchByName) {
        return true;
      } else {
        return org.displayName.toLowerCase().includes(searchByName.toLowerCase());
      }
    });

  const openNomination = () => {
    setFilterModalOpen(true);
  };

  const closeModal = () => {
    setFilterModalOpen(false);
  };

  const onClickSubmitOrganisations = () => {
    if (nominatedOrganisations) {
      const request = {
        applicationNumber: props.applicationNumber || null,
        comments: nominatedOrganisations || null,
      };
      dispatch(nominateOrganisation(request));
      setShowConfirmation(true);
      setNominatedOrganisations('');
    }
  };

  const displayCrossIcon = () => {
    return searchByName.length > 0 ? (
      <img
        src={crossIcon}
        alt={'loading'}
        className={styles.crossIcon}
        onClick={() => {
          setSearchByName('');
        }}
      />
    ) : (
      ''
    );
  };

  window.addEventListener('click', function(e) {
    if (!document.getElementById('options')?.contains(e.target) && isOptionsOpen) {
      setOpenOtions(false);
      e.stopPropagation();
    }
  });

  useEffect(() => {
    if (isFilterModalOpen || isStateInfoModalOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = 'unset';
      document.body.style.height = 'initial';
      document.body.style.position = 'initial';
      document.body.style.width = 'initial';
    }
  }, [isFilterModalOpen, isStateInfoModalOpen]);

  const onOrgItemHeaderClick = ind => {
    const catArry = [...openIndex];
    catArry[ind] = !catArry[ind];
    setOpenIndex(catArry);
  };

  return (
    <div className={`${props.fullWidth ? null : `container`}`}>
      <div className={styles.siteContainer}>
        <div className={styles.siteSubCont}>
          <div className={`${styles.mainCont} ${styles.mainContFullWidth}`}>
            {searchingOrganisations ? (
              <div className={styles.loadingCont}>
                <img src={loadingIcon} alt={'loading'} className={styles.spinner} />
                <div>Loading...</div>
              </div>
            ) : (
              <>
                <div className={`row ${styles.organisationsFrame}`}>
                  <div
                    className={`${styles.noMobilePad} col-12 ${props.fullWidth ? '' : 'col-lg-8'}`}
                  >
                    <div className={`d-flex align-items-center ${styles.listOptions}`}>
                      <div className={styles.searchInput}>
                        <div className={styles.magnifierCont}>
                          <SearchIcon className={styles.magnifier} fontSize={'large'} />
                        </div>
                        <div className={'position-relative'}>
                          <input
                            id={`searchByName`}
                            className={`${styles.inputBox} ${styles.searchInputBox}`}
                            value={searchByName}
                            onChange={event => setSearchByName(event?.target?.value.trimStart())}
                            placeholder={'Search for organisations'}
                          />
                          {displayCrossIcon()}
                        </div>
                        {searchByName.length === 0 && <p>Type the name of an organisation</p>}
                      </div>
                    </div>
                    {searchByName.length > 1 && (
                      <div className={`${styles.listContainer}`}>
                        {Object.values(
                          _.groupBy(participatingOrganisationsByCategory, 'category')
                        ).map((categoryArray, ind) => {
                          const category = categoryArray[0].category;
                          if (filteredCategories.findIndex(i => i.category === category) > -1) {
                            return (
                              <div className={styles.participatingOrgItem}>
                                <ParticipatingOrgSearchItem
                                  category={category}
                                  categoryArray={filteredCategories.filter(
                                    c => c.category === category
                                  )}
                                  showCheckbox={false}
                                  clearError={props.clearError}
                                  setSelectedOrganisations={props.setSelectedOrganisations}
                                  filterIsAwareSuperSubsidiariesSelected={
                                    props.filterIsAwareSuperSubsidiariesSelected
                                  }
                                  setIsAwareSubsidiaryShown={props.setIsAwareSubsidiaryShown}
                                  selectionEnabled={props.selectionEnabled}
                                  selectedNotifiableOrganisations={
                                    props.selectedNotifiableOrganisations
                                  }
                                  index={ind}
                                  openIndex={openIndex[ind]}
                                  onHeaderClick={onOrgItemHeaderClick}
                                  setSearchByName={setSearchByName}
                                ></ParticipatingOrgSearchItem>
                              </div>
                            );
                          }
                        })}
                      </div>
                    )}

                    {/* no search results  */}
                    {searchByName.length > 1 && filteredCategories.length === 0 && (
                      <div className={`${styles.noResult} ${styles.listContainer}`}>
                        <p>
                          <b>No result found</b>
                        </p>
                        <p>
                          We invite you to{' '}
                          <a
                            onClick={() => {
                              openNomination();
                              setShowConfirmation(false);
                            }}
                          >
                            nominate an organisation
                          </a>{' '}
                          to join this service
                        </p>
                      </div>
                    )}

                    <Modal
                      isOpen={isFilterModalOpen}
                      onRequestClose={closeModal}
                      style={customStyles}
                      contentLabel="Nominate organisation modal"
                    >
                      {!showConfirmation && (
                        <div className={styles.nominateText}>
                          <h2>Nominate an organisation</h2>
                          <p>
                            If you know of an organisation that could benefit from being included,
                            please name. Your suggestion will be anonymous.
                          </p>
                          <div className="mb-4">
                            <TextInput
                              name="nominatedOrganisations"
                              value={nominatedOrganisations || ''}
                              onInput={e => {
                                setNominatedOrganisations(e);
                                setShowConfirmation(false);
                              }}
                            />
                          </div>
                          <Button onClick={onClickSubmitOrganisations}>Submit</Button>
                        </div>
                      )}

                      {showConfirmation && (
                        <div className={styles.thankyouWrapper}>
                          <h2>Thank you!</h2>
                          <p>
                            Thank you for nominating an organisation to participate in our service.
                          </p>
                          <Button
                            onClick={() => {
                              setFilterModalOpen(false);
                              setSearchByName('');
                            }}
                          >
                            Return to notify organisations
                          </Button>
                        </div>
                      )}
                    </Modal>

                    {props.showNominateOrg ? <NominateOrganisation /> : null}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipatingOrgSearchList;
